import React from "react";
import { Text, View } from "@react-pdf/renderer";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import TableGroup from "../../../exportacion_react_pdf/TableGroup";
import QuestionResponse from "../../../exportacion_react_pdf/QuestionResponse";

// Define el documento
const ExportPaso7 = ({ formData = {}, styles = {} }) => (
  <>
    {/* Producto Representativo */}
    <View style={styles.section}>
      <Text style={styles.title_1}>
        VII. Verificación de activos o insumos entregados al Proyecto Productivo
      </Text>

      <TableGroup
        questionTitle="Describa brevemente los activos o insumos que tiene el proyecto productivo (incluidos semovientes)"
        headers={[
          "activo_insumo",
          "fuente",
          "otra_fuente",
          "estado",
          "esta_en_uso",
        ]}
        headerDescriptions={[
          "Activo",
          "Fuente",
          "Otra fuente",
          "Estado",
          "¿Está en uso?",
        ]}
        data={formData?.lista_activos_insumos_proyecto_productivo || []}
      />

      <TextAreaLabel
        label={"¿Observaciones"}
        value={formData?.observaciones_activos_insumos_entregados_proyecto || ""}
      ></TextAreaLabel>

      <CheckboxGroup
        label="¿Los insumos recibidos se utilizan totalmente en el proyecto productivo?"
        selectedValue={formData?.insumos_utilizan_totalmente_proyecto || ""}
      ></CheckboxGroup>

      {formData?.insumos_utilizan_totalmente_proyecto === "No" && (
        <TextAreaLabel
          label={
            "Indique las razones por las cuales los insumos no fueron utilizados en su totalidad en el proyecto productivo"
          }
          value={formData?.razones_insumos_no_fueron_utilizados_totalidad || ""}
        ></TextAreaLabel>
      )}

      <QuestionResponse
        label="¿Indique el porcentaje de las utilidades que se destina a la compra de nuevos insumos?"
        value={
          formData?.porcentaje_utilidades_compra_insumos
            ? `${formData.porcentaje_utilidades_compra_insumos}%`
            : ""
        }
      />
    </View>
  </>
);

export default ExportPaso7;
